export default __webpack_public_path__ + "static/media/eye-open.30aba87d.svg";